import ipCheck from '../ipCheck';

export default {
  modules: {
    ipCheck,
  },
};
